import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ClientEnv } from 'constants/Chat.constants';
import { JupiterClientEnvironment } from 'constants/Chat.constants';

import { projectInit } from 'actions';

export interface VoiceChatPanelState {
  isVoiceChatPanelOpen: boolean;
  clientEnv: ClientEnv;
}

const initialState: VoiceChatPanelState = {
  isVoiceChatPanelOpen: false,
  clientEnv: JupiterClientEnvironment.DRAFT,
};

const voiceChatPanelSlice = createSlice({
  name: 'voiceChatPanel',
  initialState,
  reducers: {
    openVoiceChatPanel: state => {
      state.isVoiceChatPanelOpen = true;
    },
    closeVoiceChatPanel: state => {
      state.isVoiceChatPanelOpen = false;
    },
    toggleVoiceChatPanel: state => {
      state.isVoiceChatPanelOpen = !state.isVoiceChatPanelOpen;
    },
    setVoiceClientEnv: (
      state,
      { payload: clientEnv }: PayloadAction<ClientEnv>,
    ) => {
      state.clientEnv = clientEnv;
    },
  },
  extraReducers: builder => {
    builder.addCase(projectInit, () => {
      return { ...initialState };
    });
  },
});

export const {
  openVoiceChatPanel,
  closeVoiceChatPanel,
  toggleVoiceChatPanel,
  setVoiceClientEnv,
} = voiceChatPanelSlice.actions;

export default voiceChatPanelSlice.reducer;
